<template>
  <div class="analytics-chart-wrap">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  name: "PaymentSplitTrendChart",
  props: {
    trend: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    trend: {
      deep: true,
      handler() {
        this.renderChart();
      },
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeUnmount() {
    this.destroyChart();
  },
  methods: {
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    formatDateLabel(value) {
      if (!value) {
        return "";
      }

      const text = String(value);

      if (text.includes(" ")) {
        return text.split(" ")[0];
      }

      if (text.includes("T")) {
        return text.split("T")[0];
      }

      return text;
    },
    renderChart() {
      if (!this.$refs.chartCanvas) {
        return;
      }

      this.destroyChart();

      const labels = this.trend.map((item) => this.formatDateLabel(item.date));
      const coinRevenue = this.trend.map((item) => Number(item.coin_revenue || 0));
      const cardRevenue = this.trend.map((item) => Number(item.card_revenue || 0));
      const coinPct = this.trend.map((item) => Number(item.coin_pct || 0));
      const cardPct = this.trend.map((item) => Number(item.card_pct || 0));

      this.chartInstance = new Chart(this.$refs.chartCanvas, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Physical Revenue (Coin+Cash)",
              data: coinRevenue,
              backgroundColor: "rgba(95, 158, 160, 0.7)",
              borderColor: "#5f9ea0",
              borderWidth: 1,
              yAxisID: "yRevenue",
            },
            {
              label: "Card Revenue",
              data: cardRevenue,
              backgroundColor: "rgba(43, 46, 70, 0.7)",
              borderColor: "#2b2e46",
              borderWidth: 1,
              yAxisID: "yRevenue",
            },
            {
              label: "Physical Share %",
              data: coinPct,
              type: "line",
              borderColor: "#0dcaf0",
              backgroundColor: "rgba(13, 202, 240, 0.2)",
              borderWidth: 2,
              pointRadius: 2,
              tension: 0.2,
              yAxisID: "yPct",
            },
            {
              label: "Card Share %",
              data: cardPct,
              type: "line",
              borderColor: "#fd7e14",
              backgroundColor: "rgba(253, 126, 20, 0.2)",
              borderWidth: 2,
              pointRadius: 2,
              tension: 0.2,
              yAxisID: "yPct",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              position: "top",
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 45,
                minRotation: 0,
              },
            },
            yRevenue: {
              beginAtZero: true,
              position: "left",
              title: {
                display: true,
                text: "Revenue (GEL)",
              },
            },
            yPct: {
              beginAtZero: true,
              position: "right",
              max: 100,
              grid: {
                drawOnChartArea: false,
              },
              title: {
                display: true,
                text: "Share %",
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.analytics-chart-wrap {
  position: relative;
  width: 100%;
  min-height: 300px;
}
</style>
